import React from "react";
import Layout from "./src/commponents/Layout/Layout";
import GlobalContextProvider from "./src/Contexts/GlobalContext";
import { Helmet } from "react-helmet";
import { navigate } from "gatsby";

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  console.log("new pathname", location);
  console.log("old pathname", prevLocation);

  if (prevLocation && !location.pathname.includes("purchased")) {
    const searchParams = new URLSearchParams(prevLocation.search);
    const searchParamsNew = new URLSearchParams(location.search);

    if ([...searchParams].length > 0 && [...searchParamsNew].length === 0) {
      navigate(`${location.pathname}?${searchParams}`, {
        replace: true,
      });
    }
  }
};

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};

export const wrapPageElement = ({ element, location }) => {
  return (
    <>
      {" "}
      <Helmet>
        <script type="text/javascript">
          var baseurl = "pdfwriter.com/lp2";
        </script>
        <script
          async
          type="text/javascript"
          src="https://track.pdfpro10.com/static/tracking.js"
        ></script>
        <script type="text/javascript">{`
          !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
          window.Beacon('init', '${process.env.GATSBY_HELPSCOUT_BEACON_ID}');
        `}</script>
      </Helmet>{" "}
      <Layout location={location}>{element}</Layout>
    </>
  );
};
